import React from "react";
import Container from "../Container";
import "./index.scss";

export const PageTitle: React.FC<{ text: string }> = ({ text }) => {
    return (
        <div className="page-title">
            <Container>
                <h2 className="page-title-inner noto-sans-jp-black">
                    {text}
                </h2>
            </Container>
        </div>
    );
};

export default PageTitle;
